import apiURL from "@/data/api";

function trimQuotes(value) {
  return value.replace(/^['"]|['"]$/g, "");
}

function normalizeBackendOrigin(candidate) {
  let normalized = trimQuotes((candidate || "").trim());

  if (!normalized) {
    return "";
  }

  normalized = normalized.replace(/\/+$/g, "");
  normalized = normalized.replace(/^wss:\/\//i, "https://");
  normalized = normalized.replace(/^ws:\/\//i, "http://");
  normalized = normalized.replace(/\/api\/v1$/i, "");
  normalized = normalized.replace(/\/api$/i, "");
  normalized = normalized.replace(/\/apis$/i, "");
  normalized = normalized.replace(/\/ws$/i, "");

  return normalized;
}

function joinURL(base, path = "") {
  const normalizedBase = (base || "").replace(/\/+$/g, "");
  const normalizedPath = String(path || "").replace(/^\/+/g, "");

  if (!normalizedPath) {
    return normalizedBase;
  }

  return `${normalizedBase}/${normalizedPath}`;
}

function toWebSocketOrigin(origin) {
  if (origin.startsWith("https://")) {
    return origin.replace(/^https:\/\//i, "wss://");
  }

  if (origin.startsWith("http://")) {
    return origin.replace(/^http:\/\//i, "ws://");
  }

  return origin;
}

const backendOrigin = normalizeBackendOrigin(
  process.env.VUE_APP_BACKEND_ORIGIN ||
    process.env.VUE_APP_API_BASE_URL ||
    process.env.VUE_APP_WS_API_BASE_URL
);

if (!backendOrigin) {
  throw new Error(
    "Missing backend origin. Set VUE_APP_BACKEND_ORIGIN for the frontend build."
  );
}

const backendConfig = Object.freeze({
  origin: backendOrigin,
  apiBaseURL: joinURL(backendOrigin, apiURL.stage),
  webSocketOrigin: toWebSocketOrigin(backendOrigin),
  openapiURL: joinURL(backendOrigin, apiURL.api.openapi),
  staticBaseURL: joinURL(backendOrigin, apiURL.static.prefix),
});

export function buildBackendURL(path) {
  return joinURL(backendConfig.origin, path);
}

export function buildApiURL(path) {
  return joinURL(backendConfig.apiBaseURL, path);
}

export function buildWebSocketURL(path) {
  return joinURL(backendConfig.webSocketOrigin, path);
}

export default backendConfig;
